import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileListComponent } from '../../components/file-list/file-list.component';
import { SvgIconComponent } from 'angular-svg-icon';

/**
 * Downloads page component.
 *
 * @remarks Displays a list of downloadable files and resources for users.
 * Integrates with the FileListComponent to provide an organized view of
 * available downloads with appropriate file icons and metadata.
 */
@Component({
  selector: 'app-downloads',
  templateUrl: './downloads.component.html',
  styleUrls: ['./downloads.component.scss'],
  standalone: true,
  imports: [CommonModule, FileListComponent, SvgIconComponent],
})
export class DownloadsComponent {}
